// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__9a7b8","loading":"Skeleton_loading__plK0r","wrapper":"Skeleton_wrapper__JKmdE","show":"Skeleton_show__DVUV7"};